import React from 'react';
import PropTypes from 'prop-types';
import { caseGuides, overviewGuide } from './caseGuides';

export const OVERVIEW_TAB = 'overview';

// 탭 옆에 붙일 작성 상태(작성됨/필수 미작성/미작성)를 정한다.
function tabState(field, value) {
    if (value.trim()) return { mark: '✓', label: '작성됨', className: 'done' };
    if (field.required) return { mark: '*', label: '필수 항목, 아직 작성하지 않음', className: 'required' };
    return { mark: '', label: '아직 작성하지 않음', className: '' };
}

// 사례개념화 항목과 전체 보기를 고르는 상단 탭.
export default function CaseFieldTabs({ fields, values, activeKey, onSelect }) {
    const written = fields.filter(field => values[field.key].trim()).length;
    return <div className="case-tabs-bar">
        <nav className="case-tabs" aria-label="사례개념화 항목">
            {fields.map((field, index) => {
                const state = tabState(field, values[field.key]);
                return <button key={field.key} type="button" className={`case-tab ${state.className}`} aria-current={activeKey === field.key ? 'true' : undefined} onClick={() => onSelect(field.key)}>
                    <b>{index + 1}</b>{caseGuides[field.key]?.tabLabel || field.label}
                    <span className="case-tab-mark" aria-hidden="true">{state.mark}</span><span className="case-sr-only">{state.label}</span>
                </button>;
            })}
            <button type="button" className="case-tab case-tab-overview" aria-current={activeKey === OVERVIEW_TAB ? 'true' : undefined} onClick={() => onSelect(OVERVIEW_TAB)}>{overviewGuide.tabLabel}</button>
        </nav>
        <span className="ai-small" role="status">{written} / {fields.length} 작성</span>
    </div>;
}

CaseFieldTabs.propTypes = {
    fields: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string.isRequired, label: PropTypes.string.isRequired, required: PropTypes.bool })).isRequired,
    values: PropTypes.objectOf(PropTypes.string).isRequired,
    activeKey: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
};
